import { configureAuth } from "react-query-auth";
import { useRoutes } from "react-router-dom";
import {
  loginWithEmailAndPassword,
  getUser,
  registerWithEmailAndPassword,
} from "features/auth";
import storage from "../utils/storage";
import { catchAsync } from "utils/catchAsunc";

import { publicRoutes } from "routes/public";
import { Spin } from "antd";

async function handleUserResponse(data) {
  const token = data?.token;
  const user = data?.data?.user ?? data?.user ?? null;
  if (token) {
    storage.setToken(token);
  }
  return user;
}

const loadUser = catchAsync(async () => {
  const token = storage.getToken();
  if (!token) return null;

  try {
    const response = await getUser();
    // adminme → { status, data: { user } } after axios unwrap
    return response?.data?.user ?? response?.user ?? null;
  } catch (err) {
    storage.clearToken();
    return null;
  }
});

const loginFn = catchAsync(async (data) => {
  const response = await loginWithEmailAndPassword(data);
  const user = await handleUserResponse(response);
  return user;
});

const registerFn = catchAsync(async (data) => {
  const response = await registerWithEmailAndPassword(data);
  const user = await handleUserResponse(response);
  return user;
});

const logoutFn = catchAsync(async () => {
  storage.clearToken();
  window.location.assign(window.location.origin);
});

const authConfig = {
  userFn: loadUser,
  loginFn,
  registerFn,
  logoutFn,
};

export const { AuthLoader, useUser, useLogin, useLogout, useRegister } =
  configureAuth(authConfig);

const UnAuthRoute = () => {
  const element = useRoutes([...publicRoutes]);

  return <>{element}</>;
};

export const AuthProvider = ({ children }) => {
  return (
    <AuthLoader
      renderLoading={() => <Spin />}
      renderUnauthenticated={() => <UnAuthRoute />}
    >
      {children}
    </AuthLoader>
  );
};
